import request from '@/utils/request'

// 获取抬头列表
export function getHeaderList(data) {
  return request({
    method: 'post',
    path: 'invoice_header/lists',
    data
  })
}

// 保存抬头
export function saveHeader(data) {
  return request({
    method: 'post',
    path: 'invoice_header/save',
    data
  })
}


// 删除抬头
export function deleteHeader(data) {
  return request({
    method: 'post',
    path: 'invoice_header/delete',
    data
  })
}


// 获取抬头列表（所有）
export function getAllHeaderList(data) {
  return request({
    method: 'post',
    path: 'invoice_header/all',
    data
  })
}
